import React from 'react';
import { Box, Typography, Paper, Grid, Chip } from '@mui/material';
import {
  Description as DocIcon,
  Link as LinkIcon,
  Folder as FolderIcon,
} from '@mui/icons-material';

const MUTED = '#6d788c';

const ASSET_GROUPS = [
  {
    label: 'Operational Compliance',
    color: '#1565c0',
    assets: [
      { type: 'doc',    title: 'Compliance Control Matrix',          link: '' },
      { type: 'doc',    title: 'Audit Evidence Repository',          link: '' },
      { type: 'folder', title: 'Policy & Procedure Documentation',   link: '' },
    ],
  },
  {
    label: 'Azure Gov Compliance',
    color: '#6a1b9a',
    assets: [
      { type: 'doc',  title: 'Azure Gov Architecture Decision Records', link: '' },
      { type: 'link', title: 'Azure Gov Compliance Dashboard',          link: '' },
      { type: 'doc',  title: 'FedRAMP Readiness Assessment',            link: '' },
    ],
  },
];

const TYPE_ICON = { doc: DocIcon, link: LinkIcon, folder: FolderIcon };

const H22026Assets = () => (
  <Box>
    <Grid container spacing={3}>
      {ASSET_GROUPS.map(group => (
        <Grid item xs={12} md={6} key={group.label}>
          <Paper elevation={0} sx={{ border: '1.5px solid rgba(0,0,0,0.07)', borderRadius: '14px', overflow: 'hidden' }}>
            <Box sx={{ px: 2.5, py: 1.5, bgcolor: `${group.color}0d`, borderBottom: '1px solid rgba(0,0,0,0.07)' }}>
              <Typography fontWeight={650} color="#1a1a1a" sx={{ fontSize: '0.9rem' }}>{group.label}</Typography>
            </Box>
            <Box sx={{ p: 1.5, display: 'flex', flexDirection: 'column', gap: 1 }}>
              {group.assets.map((asset, i) => {
                const Icon = TYPE_ICON[asset.type] || DocIcon;
                return (
                  <Box key={i} sx={{
                    display: 'flex', alignItems: 'center', gap: 1.5,
                    px: 2, py: 1.25, borderRadius: '8px',
                    border: '1px solid rgba(0,0,0,0.06)',
                    cursor: asset.link ? 'pointer' : 'default',
                    '&:hover': { bgcolor: 'rgba(0,0,0,0.025)' },
                  }}
                    onClick={() => asset.link && window.open(asset.link, '_blank')}
                  >
                    <Icon sx={{ fontSize: 18, color: group.color, flexShrink: 0 }} />
                    <Typography variant="body2" sx={{ flex: 1, fontSize: '0.82rem', color: '#1a1a1a' }}>
                      {asset.title}
                    </Typography>
                    {!asset.link && (
                      <Chip label="Coming Soon" size="small" sx={{ height: 18, fontSize: '0.65rem', bgcolor: 'rgba(0,0,0,0.06)', '& .MuiChip-label': { px: 0.75 } }} />
                    )}
                  </Box>
                );
              })}
            </Box>
          </Paper>
        </Grid>
      ))}
    </Grid>
    <Box sx={{ mt: 4, p: 3, bgcolor: 'rgba(0,0,0,0.025)', borderRadius: '12px', textAlign: 'center' }}>
      <Typography color={MUTED} variant="body2">
        Asset links will be populated as the H2-2026 compliance programme progresses.
      </Typography>
    </Box>
  </Box>
);

export default H22026Assets;
